import React, { createContext } from "react";

export const ChatContext = createContext({});

export default ({ children }) => {
  return (
    <ChatContext.Provider value={{}}>
      {children}
    </ChatContext.Provider>
  );
};
